export const initSectionAnimateIn = () => {
    const allElements = Array.from(
        document.querySelectorAll<HTMLElement>(".animate-in"),
    );

    const topLevelElements: HTMLElement[] = [];

    allElements.forEach((el) => {
        const parentAnimateIn = el.closest(".animate-in");
        if (parentAnimateIn && parentAnimateIn !== el) {
            // It's nested inside another .animate-in → activate immediately
            el.classList.add("animate-in--active");
        } else {
            // Top-level .animate-in → observe it
            topLevelElements.push(el);
        }
    });

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const el = entry.target as HTMLElement;
                    el.classList.add("animate-in--active");
                    observer.unobserve(el);
                }
            });
        },
        {
            rootMargin: "0px 0px -50px 0px", // triggers when 50px is visible from the bottom
            threshold: 0,
        },
    );

    topLevelElements.forEach((el) => observer.observe(el));
};
